import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import client, { getApiError } from '../../../api/client';
import { useAuth } from '../../../Auth/AuthContext';

const Notificationbar = () => {
  const [notificationDropDown, setNotificationDropDown] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { user } = useAuth();
  const unread = useMemo(() => notifications.filter((item) => !item.read_at).length, [notifications]);

  const loadNotifications = useCallback(async () => {
    setLoading(true); setError('');
    try { const { data } = await client.get('/notifications'); setNotifications(data.data || []); }
    catch (requestError) { setError(getApiError(requestError, 'Unable to load notifications.')); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { if (user) loadNotifications(); }, [user?.company?.id]);

  const markRead = async (notification) => {
    if (notification.read_at) return;
    try {
      await client.patch(`/notifications/${notification.id}/read`);
      setNotifications((items) => items.map((item) => item.id === notification.id ? { ...item, read_at: new Date().toISOString() } : item));
    } catch (requestError) { setError(getApiError(requestError, 'Unable to update notification.')); }
  };

  return (
    <li className='onhover-dropdown'>
      <button type='button' className='notification-box border-0 bg-transparent' aria-label={`Notifications, ${unread} unread`} aria-expanded={notificationDropDown} onClick={() => setNotificationDropDown(!notificationDropDown)}>
        <SvgIcon iconId='notification' />
        {unread > 0 && <span className='badge rounded-pill badge-secondary'>{unread > 99 ? '99+' : unread}</span>}
      </button>
      <div className={`notification-dropdown onhover-show-div ${notificationDropDown ? 'active' : ''}`}>
        <h6 className='f-18 mb-0 dropdown-title'>Notifications</h6>
        <ul>
          {loading && <li><p className='text-muted mb-0'>Loading…</p></li>}
          {error && <li><p className='text-danger mb-0' role='alert'>{error}</p></li>}
          {!loading && !error && notifications.length === 0 && <li><p className='text-muted mb-0'>You have no notifications.</p></li>}
          {notifications.slice(0, 5).map((notification) => <li key={notification.id} className={notification.read_at ? '' : 'b-l-primary border-4'}>
            <button type='button' className='border-0 bg-transparent text-start p-0 w-100' onClick={() => markRead(notification)}>
              <p className='mb-0'>{notification.data?.message || notification.data?.title || 'Workspace update'}</p>
            </button>
          </li>)}
          {!loading && <li><button type='button' className='btn btn-link f-w-700 p-0' onClick={loadNotifications}>Refresh</button></li>}
        </ul>
      </div>
    </li>
  );
};

export default Notificationbar;
